export function CreditCardLight({ width = 16 }: { width?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"
      width={width}
      fill="none"
    >
      <path
        d="M64 64C46.3 64 32 78.3 32 96l0 32 512 0 0-32c0-17.7-14.3-32-32-32L64 64zM32 160l0 64 512 0 0-64L32 160zm0 96l0 160c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-160L32 256zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM96 368c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z"
        fill="currentColor"
      />
    </svg>
  );
}
